import React from "react";
import { useBnbSelector } from "../../../../redux/store";
import Container from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Container";
import * as Flex from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Flex";
import * as BasketStyles from "../../../../../../../common-deprecated/styles/v2/toyota/custom/basket/Basket";
import Packs from "./Packs";
import Extras from "./Extras";
import Finance from "./Finance";
import Insurance from "./Insurance";
import DisclaimerContainer from "../../common/disclaimer/DisclaimerContainer";
import FinanceInsuranceCta from "./FinanceInsuranceCta";
import MostPopularExtras from "./MostPopularExtras";
import BasketFinanceTogglePanel from "../../common/basket-financetoggle-panel/BasketFinanceTogglePanel";
import Basket from "../../common/basket/Basket";
import SidebarWrapper from "../../../../../../../common-deprecated/components/SidebarWrapper";
import BottomNavigation from "../../common/nav/BottomNavigation";
import { GreyBackground } from "../../../../../../../common-deprecated/styles/v2/toyota/utilities/Background";

import { NAV_HEIGHT } from "../../../../../../../common-deprecated/styles/v2/toyota/components/Navigation";
import { hasVisibleExtras as hasVisibleExtrasFnc } from "../../../../utils/extrasUtils";

const MainContent = (): JSX.Element => {
    const { showFinanceInsuranceInPage, enableFinanceCompare } = useBnbSelector((state) => state.bnbSettings);
    const hasVisibleExtras = useBnbSelector((state) =>
        hasVisibleExtrasFnc(state.items, !!state.bnbSettings.showPackExtras),
    );
    const packsOrExtrasAvailable = useBnbSelector(
        (state) => state.items.packs.length > 0 || (state.items.extras.length > 0 && hasVisibleExtras),
    );

    return (
        <GreyBackground pt={5}>
            <Container>
                {packsOrExtrasAvailable ? (
                    <Flex.Row justifyContent="flex-start">
                        <Flex.Col width={{ xs: 1, lg: 2 / 3 }}>
                            {showFinanceInsuranceInPage && <FinanceInsuranceCta />}
                            {enableFinanceCompare && (
                                <>
                                    <Finance showIntroduction={false} />
                                    <Insurance showIntroduction={false} />
                                </>
                            )}
                            <Packs />
                            <MostPopularExtras />
                            {hasVisibleExtras && <Extras />}
                            {showFinanceInsuranceInPage && !enableFinanceCompare && (
                                <>
                                    <Finance />
                                    <Insurance />
                                </>
                            )}
                            <BottomNavigation />
                        </Flex.Col>
                        <Flex.Col
                            display={{ xs: "none", lg: "block" }}
                            width={{ xs: 1, lg: 1 / 3 }}
                            position="relative"
                        >
                            <SidebarWrapper top={NAV_HEIGHT} paddingTop={BasketStyles.BASKET_HEADER_TOP_MARGIN}>
                                <BasketStyles.BasketHeader>
                                    <BasketFinanceTogglePanel />
                                </BasketStyles.BasketHeader>
                                <Basket attached />
                            </SidebarWrapper>
                        </Flex.Col>
                    </Flex.Row>
                ) : (
                    <Flex.Row flexDirection="column" alignItems="center">
                        <Flex.Col width={{ xs: 1, lg: 2 / 3 }}>
                            <BasketStyles.BasketHeader display={{ xs: "none", lg: "block" }}>
                                <BasketFinanceTogglePanel />
                            </BasketStyles.BasketHeader>
                            <Basket attached />
                            {(showFinanceInsuranceInPage || enableFinanceCompare) && (
                                <>
                                    <Finance showIntroduction={!enableFinanceCompare} />
                                    <Insurance showIntroduction={!enableFinanceCompare} />
                                </>
                            )}
                            <BottomNavigation />
                        </Flex.Col>
                    </Flex.Row>
                )}
            </Container>
            <GreyBackground mt={4} pb={4}>
                <Container>
                    <DisclaimerContainer showGenericFinanceDisclaimer hasDarkBackground />
                </Container>
            </GreyBackground>
        </GreyBackground>
    );
};

export default MainContent;
